export enum ActionTypes {
  GET_LOGIN_DIALOG_STATUS = "GET_LOGIN_DIALOG_STATUS",
  GET_CHECKLIST_STATUS = "GET_CHECKLIST_STATUS",
  GET_ADD_TASK_DIALOG_NAME = "GET_ADD_TASK_DIALOG_NAME",
  GET_GOOGLE_TOKEN = "GET_GOOGLE_TOKEN",
  GET_COLUMNS = "GET_COLUMNS",
  GET_LABELS = "GET_LABELS",
}
